/* Copyright (c) 2023 Xperi. All Rights Reserved. */

import {
    Error400CodeEnum,
    Error404CodeEnum,
    Error500CodeEnum,
    ErrorDefaultCodeEnum,
} from 'client-code/body-info-service';
import { ErrorTypes } from './ErrorTypes';
import { PostSignInError } from './PostSignInError';

export class BodyInfoError extends PostSignInError {
    constructor(message: string, code: string, description: string) {
        super(code, message);
        this.description = description;
        this.setCode(code);
    }

    private setCode(code: string): void {
        switch (code) {
            case ErrorDefaultCodeEnum.ApigwError:
                this.code = ErrorTypes.BODY_INFO_APIGW_ERROR_C901;
                this.type = ErrorDefaultCodeEnum.ApigwError;
                break;
            case Error400CodeEnum.BadRequest:
                this.code = ErrorTypes.BODY_INFO_BAD_REQUEST_C902;
                this.type = Error400CodeEnum.BadRequest;
                break;
            case Error500CodeEnum.InternalServerError:
                this.code = ErrorTypes.BODY_INFO_INTERNAL_SERVER_ERROR_C903;
                this.type = Error500CodeEnum.InternalServerError;
                break;
            case Error404CodeEnum.ResourceNotFound:
                this.code = ErrorTypes.BODY_INFO_RESOURCE_NOT_FOUND_C904;
                this.type = Error404CodeEnum.ResourceNotFound;
                break;
            default:
                this.code = ErrorTypes.BODY_INFO_UNKNOWN_ERROR_C905;
                this.type = 'BODY_INFO_UNKNOWN_ERROR';
        }
    }
}
